(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("enzyme-react-intl", [], factory);
	else if(typeof exports === 'object')
		exports["enzyme-react-intl"] = factory();
	else
		root["enzyme-react-intl"] = factory();
})(global, function() {
return 